export const documentStatusConfig = {
	// Document status configuration for GR7 Commercial Permit
	GR7_1RenovationOrDevelopment: {
		['IA-68']: {
			planArchitecturePreliminaireInput: 'required',
			ficheBatimentInput: 'optional',
			autresSiRequisInput: 'optional'
		},
		['PA-14']: {
			planArchitectureInput: 'required',
			ficheBatimentInput: 'required',
			planMecaniqueInput: 'optional',
			planElectriqueInput: 'optional',
			planVentilationInput: 'optional',
			planCivilInput: 'optional',
			planStructureInput: 'optional',
			autresSiRequisInput: 'optional'
		}
	},
	GR7_2RequestOccupation: {
		['CO-7']: {
			planAmenagementInput: 'required',
			bailSiRequisInput: 'optional',
			autresSiRequisInput: 'optional'
		},
		['CO-37']: {
			planAmenagementInput: 'required',
			bailSiRequisInput: 'optional',
			autresSiRequisInput: 'optional'
		}
	},
	GR7_3HomeOfficeOrBusiness: {
		['CO-9']: {
			planAmenagementInput: 'required',
			autresSiRequisInput: 'optional'
		}
	},
	GR7_4InstallationOfEnseigne: {
		['IA-60']: {
			photographieInput: 'required',
			planAEchelleInput: 'required',
			planImplantationArpenteurGrandeEmpriseInput: 'optional',
			certificatDeLocalisationInput: 'optional',
			ficheBatimentInput: 'optional',
			autresSiRequisInput: 'optional'
		},
		['CA-8']: {
			planAEchelleInput: 'required',
			planImplantationArpenteurGrandeEmpriseInput: 'optional',
			certificatDeLocalisationInput: 'optional',
			photographieInput: 'optional',
			autresSiRequisInput: 'optional'
		}
	}
}
